<app-nav-header></app-nav-header>
<app-sidebar-menu></app-sidebar-menu>
<ngx-loading [show]="loading"> </ngx-loading>
<div class="page-content-wrapper">
  <div class="page-content">
    <div class="page-bar">
      <div class="page-title-breadcrumb">
        <div class="container">
          <div class="card card-topline-green">
            <div class="card-head">
              <header>Visualizar Alerta</header>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Nome</b>
                    </div>
                    <div class="col-md-12">
                      {{ alert.name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Variável</b>
                    </div>
                    <div class="col-md-12">
                      {{ alert.variable }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Tipo</b>
                    </div>
                    <div class="col-md-12">
                      {{ alert.alertType.name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Origem</b>
                    </div>
                    <div class="col-md-12">
                      <!-- {{ alert.alertType.origin }} -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Opção</b>
                    </div>
                    <div class="col-md-12">
                      <!-- {{ alert.alertType.origin }} -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <div class="col-md-12">
                      <b>Status</b>
                    </div>
                    <div class="col-md-12">
                      <span
                        *ngIf="alert.active"
                        class="label label-sucess label-mini"
                        >Ativo</span
                      >
                      <span
                        *ngIf="!alert.active"
                        class="label label-danger label-mini"
                        >Inativo</span
                      >
                    </div>
                    <div class="col-md-6"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row d-flex justify-content-center my-5">
                <div class="m-2">
                  <a routerLink="/parameters/alert/edit/{{ alert.id }}" class="btn btn-warning"
                    >Editar</a
                  >
                </div>
                <div class="m-2">
                  <a routerLink="/parameters/alert" class="btn btn-info">Voltar</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
